import type { FC } from 'react';
import { createElement } from 'react';

import _ from '@luna/lodash';
import type { BaseUseNavigateOptions, NavigateFunction } from '@luna/router';

import type { NavigationMap } from './typing';

type NavigationOptions = Omit<BaseUseNavigateOptions, 'absolute'>;

type NavigationParam = {
    navigate: NavigateFunction;
    navigateComponent: FC<{ to: string } & NavigationOptions>;
};

const getLastPartOfNavigation = (navigation: string): string => {
    const parts = navigation.split('/');

    return parts[parts.length - 1];
};

export const createNavigationMap = <Path extends string>(
    { navigate, navigateComponent }: NavigationParam,
    ...navigations: Path[]
): NavigationMap<Path> =>
    navigations.reduce(
        (result, navigation) => ({
            ...result,
            [_.camelCase(getLastPartOfNavigation(navigation))]: [
                (options?: NavigationOptions) => navigate(navigation, options ?? {}),
                (options?: NavigationOptions) =>
                    createElement(navigateComponent, { to: navigation, ...options }),
            ],
        }),
        {} as NavigationMap<Path>,
    );
